export function syncRunPollInterval(statuses: string[]): number | false {
  const active = statuses.some((status) => status === 'queued' || status === 'running' || status === 'preprocessing');
  return active ? 5000 : false;
}
